import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import airowIcon from "@/assets/airow-icon.png";

const Landing = () => {
  const { i18n } = useTranslation();
  const fr = i18n.language?.startsWith("fr");

  const copy = fr
    ? {
        title: "Portail client Airow Studio",
        subtitle:
          "Un espace sécurisé pour suivre vos projets, consulter vos factures et échanger avec l'équipe.",
        signIn: "Se connecter",
        site: "En savoir plus sur airow.ca",
      }
    : {
        title: "Airow Client Portal",
        subtitle:
          "A secure workspace to follow your projects, review invoices, and talk with the team.",
        signIn: "Sign in",
        site: "Learn more at airow.ca",
      };

  return (
    <main className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center shadow-lg">
        <img
          src={airowIcon}
          alt="Airow Studio"
          className="mx-auto h-12 w-12"
          loading="lazy"
        />
        <h1 className="mt-6 font-heading text-2xl font-semibold text-foreground">
          {copy.title}
        </h1>
        <p className="mt-3 text-sm text-muted-foreground">{copy.subtitle}</p>

        <div className="mt-8 flex flex-col gap-3">
          <Button asChild size="lg">
            <a href="https://airow.ca" target="_blank" rel="noopener noreferrer">
              {copy.site}
              <ArrowRight className="ml-2 h-4 w-4" />
            </a>
          </Button>
          <Button asChild variant="ghost" size="lg">
            <Link to="/auth">{copy.signIn}</Link>
          </Button>
        </div>
      </div>
    </main>
  );
};

export default Landing;
